namespace GeniuzPOS.ReportMasterData {
    export interface Report_1406Form {
    }

    export class Report_1406Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1406';
    }
}
